import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE, UPLOADS_BASE } from '../apiConfig';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../css/about.css';
import '../css/blog.css';
import { useNavigate } from 'react-router-dom';

function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    axios
      .get(`${API_BASE}/blog`)
      .then((res) => {
        // Filter to show only blog posts
        const blogPosts = (res.data || []).filter(post => post.post_type === 'blog');
        setPosts(blogPosts);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching blog:', err.message);
        setError('Failed to load articles');
        setLoading(false);
      });
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid about-bg10 d-flex align-items-end" style={{ minHeight: '60vh', padding: 0, top: '-122px' }}>
        <div className="container about-content my-5">
          <div className="row">
            <div className="col-lg-8 col-md-10 col-12 about-text my-5">
              <h1 className="about-title text-white mb-2">Insights & Updates</h1>
              <p className="about-desc text-white-50 mb-3">Explore articles, news, and industry perspectives from Petrochoice.</p>
              <div className="about-underline"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Blog Posts Section */}
      <div className="blog-section">
        <div className="container">
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3 gap-2">
            <h2 className="title mb-0" data-aos="fade-down" style={{ color: '#1565c0', fontWeight: 700 }}>Latest Articles</h2>
            <div className="ms-md-auto" style={{maxWidth: 360, width: '100%'}}>
              <input
                type="search"
                className="form-control"
                placeholder="Search articles..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
          </div>
          {loading && (
            <div className="text-center text-muted py-5">Loading...</div>
          )}
          {!loading && error && (
            <div className="alert alert-danger">{error}</div>
          )}
          {!loading && !error && posts.length === 0 && <div className="text-center text-muted">No articles yet.</div>}
          <div className="row">
            {posts
              .filter(p => search ? (p.title || '').toLowerCase().includes(search.toLowerCase()) : true)
              .map((post, idx) => (
              <div key={post.id} className="col-md-6 col-lg-4 mb-4" data-aos="zoom-in" data-aos-delay={idx * 120}>
                <div className="card blog-card h-100 shadow-sm rounded-4 border-0" style={{transition:'transform .2s ease'}}>
                  {post.image && (
                    <img
                      src={`${UPLOADS_BASE}/${post.image}`}
                      alt="Blog"
                      className="blog-card-img rounded-top-4"
                      style={{ objectFit: 'cover', height: '220px', width: '100%' }}
                    />
                  )}
                  <div className="card-body d-flex flex-column">
                    <h5 className="blog-card-title mb-2" style={{ fontWeight: 700 }}>{post.title}</h5>
                    <div className="mb-2 text-muted" style={{ fontSize: '0.9em' }}>
                      <span>By: {post.author || 'Unknown'}</span>
                      <span className="mx-2">|</span>
                      <span>{post.created_at ? new Date(post.created_at).toLocaleDateString() : ''}</span>
                    </div>
                    <p className="text-muted small mb-3" style={{minHeight: '48px'}}>
                      {(post.meta_description || '').slice(0, 110)}{(post.meta_description || '').length > 110 ? '…' : ''}
                    </p>
                    <button
                      className="btn btn-primary mt-auto"
                      style={{ borderRadius: '20px', fontWeight: 600 }}
                      onClick={() => navigate(`/blog/${post.slug}`)}
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog;